// This file automatically generated by skymarshal.
// DO NOT MODIFY BY HAND!!!!
//
// From Source File: vehicle/planner/lcmtypes/movement.lcm
import Long from "long";
import Decoder from "@skydio/lcm/src/decoder";
import Encoder from "@skydio/lcm/src/encoder";
import LcmEnumMsg from "@skydio/lcm/src/enum";

enum option_t {
  LANDSCAPE = 0,
  LANDSCAPE_FLIPPED = 1,
  AUTO = 2,
}

export class gimbal_orientation_mode_t extends LcmEnumMsg {
  public static override option_t = option_t;
  private static _hash = Long.fromString("11999453122282051735", true);
  private static _packed_fingerprint?: Long;

  /** @internal */
  public static override _get_packed_fingerprint(): Long {
    if (gimbal_orientation_mode_t._packed_fingerprint === undefined) {
      gimbal_orientation_mode_t._packed_fingerprint = gimbal_orientation_mode_t._get_hash_recursive([]);
    }
    return gimbal_orientation_mode_t._packed_fingerprint;
  }

  /** @internal */
  public static override _get_hash_recursive(parents: any[]): Long {
    if (parents.indexOf(gimbal_orientation_mode_t) > -1) {
      return Long.fromNumber(0, true);
    }
    let tmp_hash = gimbal_orientation_mode_t._hash;
    tmp_hash = tmp_hash.shl(1).add(tmp_hash.shru(63));
    return tmp_hash;
  }

  public override decode(array: Uint8Array): gimbal_orientation_mode_t {
    const decoder = new Decoder(
      new DataView(array.buffer, array.byteOffset, array.byteLength)
    );
    const hash = decoder.decode_hash();
    if (!hash.equals(gimbal_orientation_mode_t._get_packed_fingerprint())) {
      console.error("Hash mismatch", hash, gimbal_orientation_mode_t._get_packed_fingerprint());
      throw new Error("Hash mismatch!");
    }
    this.decode_one(decoder);
    return this;
  }

  // Recursively decode a message with the supplied decoder.
  public override decode_one(decoder: Decoder): gimbal_orientation_mode_t {
    this.value = decoder.decode_int32_t();
    return this;
  }

  /** @internal */
  public _get_encoded_size(): number {
    return 4;
  }

  public override encode(): ArrayBufferLike {
    const total_size = this._get_encoded_size();
    const encoder = new Encoder(total_size);
    this.encode_one(encoder);
    return encoder.view.buffer;
  }

  public override encode_one(encoder: Encoder): void {
    encoder.encode_int32_t(this.value);
  }

  // static constructors
  static get LANDSCAPE() {
    return new gimbal_orientation_mode_t(option_t.LANDSCAPE);
  }
  static get LANDSCAPE_FLIPPED() {
    return new gimbal_orientation_mode_t(option_t.LANDSCAPE_FLIPPED);
  }
  static get AUTO() {
    return new gimbal_orientation_mode_t(option_t.AUTO);
  }

  public override value: option_t;

  constructor(value?: option_t) {
    super();
    this.value = value ?? option_t.LANDSCAPE;
  }

  public override get name(): string {
    return option_t[this.value]!;
  }
}